module.exports = __webpack_public_path__ + "assets/img/main-show.bc41b08b.png";